export const Collapse = {
	selectors: {
		collapseOpen: Array.prototype.slice.call(document.querySelectorAll('.js-collapse')),
		collapseOpened: Array.prototype.slice.call(document.querySelectorAll('.js-collapse.is-active')),
		collapseParentClass: '.c-collapse'
	},
	init: function () {
		let self = this;

		self.collapseToggleEvent(this.selectors.collapseOpen);

		self.selectors.collapseOpen.forEach(function (x) {
			let target = self.detectTargetAttr(x);

			if (target.classList.contains('is-open')) {
				x.classList.add('is-active');
			}
		});
	},

	collapseToggleEvent: function (_selector) {
		let self = this;

		_selector.forEach(function (x) {
			const groupElement = self.detectGroupAttr(x);

			x.classList.remove('is-active');

			x.addEventListener('click', function (event) {
				event.preventDefault();
				let target = self.detectTargetAttr(x);

				// deactivate active element in group
				if (groupElement) {
					const active = Array.prototype.slice.call(groupElement.querySelectorAll('.js-collapse.is-active'))

					active.forEach(function (activeElement) {
						if (activeElement !== x) {
							activeElement.click()
						}
					})
				}

				// activate clicked element
				if (!target.classList.contains('is-collapsing')) {

					if (this.classList.contains('is-active')) {
						this.classList.remove('is-active');
					} else if (!this.classList.contains('is-active')) {
						this.classList.add('is-active');
					}
					self.toggleTab(target);
				}
			});
		});
	},

	detectGroupAttr: function (_element) {
		let group;

		if (_element.hasAttribute('data-group')) {
			group = _element.getAttribute('data-group');
			return document.getElementById(`${group.substr(1)}`);
		}

		return null;
	},

	detectTargetAttr: function (_element) {
		let target;

		if (_element.hasAttribute('data-target')) {
			target = _element.getAttribute('data-target');
		} else if (_element.hasAttribute('href')) {
			target = _element.getAttribute('href');
		}

		return document.getElementById(`${target.substr(1)}`);
	},

	toggleTab: function (_selector) {
		let self = this;

		if (_selector.offsetHeight === 0) {
			self.openTab(_selector);
		} else {
			self.closeTab(_selector);
		}
	},

	openTab: function (_selector) {
		_selector.style.display = 'block';
		let height = _selector.offsetHeight;
		_selector.style.display = '';

		_selector.classList.add('is-collapsing');

		setTimeout(function () {
			_selector.style.height = `${height}px`;
		}, 1);

		setTimeout(function () {
			_selector.classList.remove('is-collapsing');
			_selector.classList.add('is-open');
			_selector.style.height = '';
		}, 350);
	},

	closeTab: function (_selector) {
		let height = _selector.offsetHeight;

		_selector.style.height = `${height}px`;

		_selector.classList.add('is-collapsing');
		_selector.classList.remove('is-open');

		setTimeout(function () {
			_selector.style.height = '0px';
		}, 1);

		setTimeout(function () {
			_selector.classList.remove('is-collapsing');
			_selector.style.height = '';
		}, 350);
	},

	hideOtherTab: function (_this, _selector) {
		let self = this;
		let array = _selector;

		array.forEach(function (x) {
			let target = self.detectTargetAttr(x);
			// let parentClass = x.closest(self.selectors.collapseParentClass);

			// if (x !== _this) {
			// 	console.log('zavri ostatne');
			// 	parentClass.classList.remove('is-active');
			// }

			// parentClass.classList.remove('is-active');

			if (target.classList.contains('is-open')) {
				self.closeTab(target);
			}
		});
	}
};

window.Collapse = Collapse;
Collapse.init();
